module.exports = __webpack_public_path__ + "static/media/pay.088242d2.png";